"use client"

import {useEffect, useState} from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import {Button} from "@/components/ui/button"
import {useRouter} from "next/navigation";

interface EmailExistsPopupProps {
  isOpen: boolean
  onClose: () => void
  email: string
}

export function EmailExistsPopup({ isOpen, onClose, email }: EmailExistsPopupProps) {
  const [open, setOpen] = useState(isOpen);
  const router = useRouter();

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  const handleClose = () => {
    setOpen(false)
    onClose()
  }

  const goToLogin = () => {
    console.log("Navigating to login page...")
    router.push('/login');
    handleClose()
  }

  const goToForgotPassword = () => {
    console.log("Navigating to forgot password page...")
    // In a real application, you would use router.push('/forgot-password')
    router.push('/forgot-password');
    handleClose()
  }

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Email Already Exists</AlertDialogTitle>
          <AlertDialogDescription>
            The email address {email} is already associated with an account. What would you like to do?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button onClick={goToLogin}>Go to Login</Button>
          </AlertDialogAction>
          <AlertDialogAction asChild>
            <Button variant="outline" onClick={goToForgotPassword}>
              Forgot Password
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

